import React from 'react';
import { clubData } from '../data/mock';
import { ArrowRight, Instagram } from 'lucide-react';

export const Hero = ({ onJoin }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-900">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-30"
        style={{
          backgroundImage: `url(${clubData.heroImage})`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img 
            src={clubData.logo} 
            alt="Training Club Esportiu Orpí"
            className="w-64 md:w-96 h-auto animate-fade-in"
          />
        </div>

        {/* Tagline */}
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white mb-6 animate-slide-up">
          <span className="text-[#39FF14]">TRAINING</span>
          <br />
          Club Esportiu Orpí
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto">
          {clubData.tagline}
        </p>

        <p className="text-lg text-gray-400 mb-12 max-w-2xl mx-auto">
          {clubData.description}
        </p>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button
            onClick={onJoin}
            data-testid="hero-join-btn"
            className="group inline-flex items-center gap-2 bg-[#39FF14] hover:bg-[#2EDD0F] text-black px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#39FF14]/50"
          >
            Fes-te Soci
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </button>
          
          <a
            href={clubData.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2 bg-gray-800 hover:bg-gray-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 border-2 border-[#39FF14]"
          >
            <Instagram className="w-5 h-5" />
            Segueix-nos
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-[#39FF14] rounded-full mx-auto flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-[#39FF14] rounded-full animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  );
};
